(function () {
  if (window.__productPaymentMethodsScriptLoaded) return;
  window.__productPaymentMethodsScriptLoaded = true;

  function isDesktopHover() {
    return window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product-payment-methods__group-help-button');
    if (!button) return;
    if (isDesktopHover()) return;

    event.preventDefault();
    event.stopPropagation();

    const message = button.getAttribute('data-tip-text') || '';
    if (!message) return;

    if (typeof window.showToast === 'function') {
      window.showToast(message, 'normal', 5000, null, {
        maxWidth: 302,
        fontSize: 14,
        lineHeight: '150%',
        padding: 12,
        position: 'bottom',
      });
    }
  });
})();
